<template>
  <div id="featured-items" ref="featured_items">
    <BaseLoader v-if="loading" />
    <TransitionGroup v-else name="featured-list" tag="div" class="items">
      <ItemFeatured
        v-for="item in items_copy"
        :key="item.asset_id"
        :item="item"
      />
    </TransitionGroup>
  </div>
</template>

<script setup>
import ItemFeatured from '@/component/market/ItemFeatured.vue';
import BaseLoader from '@/component/body/BaseLoader.vue';
import { items_featured, form_featured } from '@/hook/market/items.js';
import { computed, watch, nextTick, ref, onBeforeUnmount } from 'vue';
import { APP_EVENT_BUS, main_bus } from '@/hook/bus.js';
import { is_mobile } from '@/hook/mobile/breakpoint.js';

const featured_items = ref(null);
const items_copy = ref([]);
let interval;

const slide = () => {
  if (items_copy.value.length) {
    items_copy.value.unshift(items_copy.value.pop());
  }
};

const stopAnimation = () => {
  clearInterval(interval);
};

const startAnimation = () => {
  interval = setInterval(slide, 3500);
};

const toggleAnimation = () => {
  if (document.hidden) {
    clearInterval(interval);
  } else {
    startAnimation();
  }
};

const init = () => {
  items_copy.value = [...items_featured.value];

  if (is_mobile.value) {
    items_copy.value = items_copy.value.slice(0, 10);
  }

  if (items_copy.value.length) {
    items_copy.value.unshift(items_copy.value.pop());
  }

  featured_items.value.addEventListener('mouseenter', stopAnimation);
  featured_items.value.addEventListener('mouseleave', startAnimation);
  document.addEventListener('visibilitychange', toggleAnimation);

  startAnimation();
};

main_bus.on(APP_EVENT_BUS.refreshItems, () => {
  stopAnimation();
  form_featured.value.onSubmit();
  items_copy.value = [];
});

const loading = computed(() => form_featured.value.is_loading.value || !form_featured.value.is_called.value);

watch(loading, (t) => {
  clearInterval(interval);

  if (!t) {
    nextTick(() => {
      init();
    });
  }
});

onBeforeUnmount(() => {
  clearInterval(interval);
  featured_items.value.removeEventListener('mouseenter', stopAnimation);
  featured_items.value.removeEventListener('mouseleave', startAnimation);
  document.removeEventListener('visibilitychange', toggleAnimation);
});
</script>

<style scoped>
.featured-list-move {
  transition: all 1.5s;
}
</style>
